import styled from 'styled-components';
import { brandColors, commonColors } from 'styles/colors';
import { Theme, getBodyStyle, getColor } from 'styles/theme';

interface ComplexityTagProps {
  $complexity: 'beginner' | 'intermediate' | 'advanced';
  theme: Theme;
}
// TODO: https://fortune.atlassian.net/browse/FFD-6301
const handleBackgroundColor = (complexity: string) => {
  switch (complexity) {
    case 'beginner':
      return `background-color: ${brandColors.recommends.shadeBrandPrimary500}`;
    case 'intermediate':
      return `background-color: ${commonColors.semanticsWarning}`;
    case 'advanced':
      return `background-color: ${brandColors.crypto.brandSecondary}`;
    default:
      break;
  }
  return null;
};

// will get back to this to investigate why this isn't working for advanced
// const handleTextColor = (complexity: string) => {
//   switch (complexity) {
//     case 'beginner':
//       return `color: ${getColor('neutralBlack')}`;
//     case 'intermediate':
//       return `color: ${getColor('neutralBlack')}`;
//     case 'advanced':
//       return `color: ${getColor('textWhite')}`;
//     default:
//       break;
//   }
//   return null;
// };

export const Container = styled.div<ComplexityTagProps>`
  ${({ $complexity }) => handleBackgroundColor($complexity)};
  display: flex;
  height: 35px;
  width: fit-content;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
`;

export const Text = styled.p<ComplexityTagProps>`
  ${getBodyStyle('graphikCond', { default: 'default' }, 'medium')};
  letter-spacing: 0.5px;
  color: ${({ $complexity }) => ($complexity === 'advanced' ? getColor('textWhite') : getColor('neutralBlack'))};
`;
